import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-right2.png'


const _withScopeId = n => (_pushScopeId("data-v-4822cf2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipment-progress" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = {
  key: 0,
  class: "arrow-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { useI18n } from 'vue-i18n';
  import { computed } from 'vue';
  import { SHIPMENT_STATE_MAP } from '@/constants';

  type Progress = {
    name: string;
    state: string | string[];
  }

  interface IProps {
    state: string;
    showCancelBtn: boolean;
    unmatched?: boolean;
    showRequestAgainBtn?: boolean;
  }

  interface IEmits {
    (event: 'cancel'): void;
    (event: 'request'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    state: null,
    showCancelBtn: { type: Boolean },
    unmatched: { type: Boolean },
    showRequestAgainBtn: { type: Boolean }
  },
  emits: ["cancel", "request"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'cancel'): void;
    (event: 'request'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    state: string;
    showCancelBtn: boolean;
    unmatched?: boolean;
    showRequestAgainBtn?: boolean;
  }

  const { t, locale } = useI18n();
  const isKo = locale.value === 'ko';
  const isJa = locale.value === 'ja';

  const progress = computed<Progress[]>(() => {
    if (isJa) {
      // https://mattermost.beansmile-dev.com/beansmile/pl/qjfddiugm3dqdf43sxstradopc
      return [
        { name: SHIPMENT_STATE_MAP['init'], state: ['init'] },
        { name: SHIPMENT_STATE_MAP['pending'], state: ['pending', 'received', 'logistic_cancelled'] },
        { name: SHIPMENT_STATE_MAP['tc_synced'], state: ['tc_synced'] },
      ];
    }
    // https://mattermost.beansmile-dev.com/beansmile/pl/1awzki1wwi8db8636exmyjokke
    return [
      { name: SHIPMENT_STATE_MAP['pending'], state: ['pending', 'waiting_pick_up'], },
      { name: SHIPMENT_STATE_MAP['shiped'], state: 'shiped' },
      { name: SHIPMENT_STATE_MAP['arrived'], state: 'arrived' },
      { name: SHIPMENT_STATE_MAP['received'], state: 'received' },
      { name: SHIPMENT_STATE_MAP['tc_synced'], state: 'tc_synced' }
    ];
  });

  
  

  const stateIndex = computed(() => {
    return progress.value.findIndex(item => {
      if (Array.isArray(item.state)) {
        return item.state.includes(props.state);
      }
      return item.state === props.state;
    });
  });

  const checkDisabled = (index: number) => {
    if (props.state === 'cancelled') {
      return index === 0;
    }
    return props.unmatched || stateIndex.value > index;
  };

  const checkActive = (state: any) => {
    if (Array.isArray(state)) {
      return state.includes(props.state);
    }
    return state === props.state;
  };

  function getName(item: Progress, index: number) {
    if (!isKo || index !== 0) {
      return item.name;
    }
    // 第一步走完了
    if (stateIndex.value > 0) {
      return '요청 승인';
    }
    // 用户点了取消
    if (props.showRequestAgainBtn) {
      return '고객취소';
    }
    return item.name;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(progress), (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["circle", { active: checkActive(item.state), disabled: checkDisabled(index)}])
          }, _toDisplayString(getName(item, index)), 3),
          (index === 0 && __props.showCancelBtn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
              }, _toDisplayString(_unref(t)('Cancel')), 1))
            : _createCommentVNode("", true),
          (index === 0 && __props.showRequestAgainBtn)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('request')))
              }, _toDisplayString(_unref(t)('Request')), 1))
            : _createCommentVNode("", true)
        ]),
        (index !== _unref(progress).length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})